import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { storage } from '@/utils/storage';
import {
  h5Routers,
  reportRouters,
  promotionRouters,
  mineRouters,
  feedbackRouters,
  taxReceiptRouters,
  financingReportRouters,
  advertisementRouters,
  miniProgramRouters,
  monthlyActivityRouters,
} from './modules';
import { getLinkIdParam, formateQuery } from '@/utils/utils';
import { userAgentLinkCheck } from '@/api/basic';

const routes = ([] as RouteRecordRaw[])
  .concat(h5Routers)
  .concat(reportRouters)
  .concat(promotionRouters)
  .concat(mineRouters)
  .concat(feedbackRouters)
  .concat(taxReceiptRouters)
  .concat(financingReportRouters)
  .concat(advertisementRouters)
  .concat(miniProgramRouters)
  .concat(monthlyActivityRouters)
  .concat({ path: '/:pathMatch(.*)*', redirect: '/404' });

console.log({ routes });

const router = createRouter({
  history: createWebHistory(), // hash 模式则使用 createWebHashHistory()
  routes,
  strict: true,
});

function saveRouterValue(name: string, value: string) {
  if (name) {
    if (name === 'token') {
      storage.setItem(name, value, null, 1);
    } else {
      storage.setItem(name, value, null, 2);
    }
    if (name === 'city') {
      storage.setItem('cityChoose', value, null, 2);
    }
  }
}

router.beforeEach((to, from, next) => {
  // 校验登录情况
  // if (to.meta && to.meta.checkAuth) {
  //   if (!storage.checkAuth()) return next('/404');
  // }
  const { path, query, params, meta } = to;
  if (meta && meta.title) {
    document.title = typeof to.meta.title === 'function' ? to.meta.title(to) : to.meta.title;
  }

  const reg = /xingdai_|iOS_|ysr_/gi;
  if (reg.test(query.platform as string)) {
    query.platform = 'H5';
    delete query.token;
    console.log('----query----', JSON.stringify(query));
  }
  for (const i in query) {
    saveRouterValue(i, <string>query[i]);
  }

  /**
   * 区别 不同报告类型的报告详情
   */
  // if (
  //   to.name === 'ReportDetailNew' &&
  //   params.reportType &&
  //   ['7', '8'].includes(params.reportType as string)
  // ) {
  //   return next({ name: 'ReportDetailV3', query, params });
  // }
  // if (
  //   to.name === 'ReportDetailV3' &&
  //   params.reportType &&
  //   ['1', '2', '3', '4', '5', '6'].includes(params.reportType as string)
  // ) {
  //   return next({ name: 'ReportDetailNew', query, params });
  // }

  const fromName = from.name;
  to.meta ? (to.meta.from = fromName) : (to.meta = { from: fromName });

  next();

  // 校验linkId
  // if (to.meta.isCheckLinkId) {
  //   const formatedParam = getLinkIdParam(to) || {};
  //   console.log({ formatedParam }, 5);

  //   if (!formatedParam.id) {
  //     // next({ path: '/404', replace: true });
  //     next({ path: '/linkInvalid', replace: true });
  //   } else {
  //     userAgentLinkCheck({ linkId: formatedParam.id })
  //       .then(() => {
  //         console.log('linkId有效');
  //         next();
  //       })
  //       .catch((err: any) => {
  //         if (err.code === '2000') {
  //           console.log({ err });
  //           if (!err.data || !err.data.h5LinkUrl) {
  //             next({ path: '/linkInvalid', replace: true });
  //           } else {
  //             // 如果最近有同类型的新链接，则前往最新链接
  //             const curQuery = formateQuery(err.data.h5LinkUrl.split('?')[1] || '');
  //             console.log({ curQuery });
  //             next({ path: to.path, query: curQuery, replace: true });
  //           }
  //         } else {
  //           next({ path: '/404', replace: true });
  //         }
  //       });
  //   }
  // } else {
  //   next();
  // }
  /*if (!storage.getItem('token')) {
    const routerList = [
      '/serviceIm',
    ];
    if (routerList.includes(to.path)) {
      next();
    } else if (to.path !== '/login') {
      // 未登录且要跳转的页面不是登录页
      next({ path: '/login' });
    } else {
      next();
    }
  } else {
    next();
  }*/
});

router.afterEach((to, from) => {
  if (to.meta && to.meta.title) {
    document.title = typeof to.meta.title === 'function' ? to.meta.title(to) : to.meta.title;
  }
  window.scrollTo(0, 0);
});

// router.onError((err) => {

// });

export default router;
